import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';

export interface ChatResponse {
  reply: string;
  conversationId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {

  constructor(private http: HttpClient) {}

  sendMessage(message: string, conversationId?: string): Observable<ChatResponse> {
    const url = `${AppConfigService.apiUrl}/chat`;
    return this.http.post<ChatResponse>(url, { message, conversationId });
  }
}
